/**
 * Admin settings: change password.
 */
import { useState } from "react";
import api, { extractErr } from "../api";
import { Button, Card, Field, Input, PageHeader } from "../ui";

export default function Settings() {
    const [current, setCurrent] = useState("");
    const [next, setNext] = useState("");
    const [next2, setNext2] = useState("");
    const [err, setErr] = useState("");
    const [ok, setOk] = useState(false);
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setOk(false);
        if (next.length < 8) {
            setErr("La nuova password deve essere di almeno 8 caratteri.");
            return;
        }
        if (next !== next2) {
            setErr("Le due nuove password non coincidono.");
            return;
        }
        setBusy(true);
        try {
            await api.post("/auth/change-password", {
                current_password: current,
                new_password: next,
            });
            setOk(true);
            setCurrent("");
            setNext("");
            setNext2("");
        } catch (e) {
            setErr(extractErr(e));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div data-testid="settings-page">
            <PageHeader
                title="Impostazioni"
                description="Cambia la password del tuo account amministratore."
            />

            <Card className="p-6 max-w-xl">
                <form onSubmit={submit} className="space-y-4">
                    <Field label="Password attuale">
                        <Input
                            type="password"
                            required
                            value={current}
                            onChange={(e) => setCurrent(e.target.value)}
                            data-testid="settings-current-password"
                        />
                    </Field>
                    <Field label="Nuova password" hint="Minimo 8 caratteri.">
                        <Input
                            type="password"
                            required
                            value={next}
                            onChange={(e) => setNext(e.target.value)}
                            data-testid="settings-new-password"
                        />
                    </Field>
                    <Field label="Conferma nuova password">
                        <Input
                            type="password"
                            required
                            value={next2}
                            onChange={(e) => setNext2(e.target.value)}
                            data-testid="settings-new-password-2"
                        />
                    </Field>
                    {err && (
                        <div className="text-xs text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">
                            {err}
                        </div>
                    )}
                    {ok && (
                        <div className="text-xs text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-md px-3 py-2">
                            Password aggiornata con successo.
                        </div>
                    )}
                    <Button type="submit" disabled={busy} data-testid="settings-submit">
                        {busy ? "Salvataggio…" : "Aggiorna password"}
                    </Button>
                </form>
            </Card>
        </div>
    );
}
